//@flow
import React from 'react';
import Modal from 'react-modal';
import IconClose from '../../Icon/components/IconClose.react';
import HeapActions from '../../Actions/heap';
import { isIOS } from '../../Utils/device';

type Props = {
  className:string,
  isOpen:?boolean,
  closeModal?:() => void,
  overlay?:string,
  children?:React$Node,
};

export default class BaseModal extends React.PureComponent<Props> {
  _IOS:boolean = isIOS();

  componentDidMount() {
    if (this.props.isOpen) {
      HeapActions.trackModal({ className: this.props.className });
    }
  }

  componentDidUpdate(prevProps:Props) {
    if (!prevProps.isOpen && this.props.isOpen) {
      HeapActions.trackModal({ className: this.props.className });
    }
  }

  getClass(props:Props):string {
    let className = 'modal';
    if (props.className) className += ' ' + props.className;
    if (this._IOS) className += ' ios';
    return className;
  }

  getCloseIcon(props:Props) {
    if (props.closeModal) return <IconClose closeAction={props.closeModal} className="modal-close" />;
  }

  getOverlay(props:Props) {
    const overlayClass = props.overlay ? ' ' + props.overlay : '';
    return 'modal-overlay' + overlayClass;
  }

  render() {
    return (
      <Modal
        className={this.getClass(this.props)}
        overlayClassName={this.getOverlay(this.props)}
        isOpen={this.props.isOpen || false}
        onRequestClose={this.props.closeModal}
        contentLabel="Modal"
        role="dialog"
        tabIndex="0"
        ariaHideApp={false}
      >
        {this.getCloseIcon(this.props)}
        {this.props.children}
      </Modal>
    );
  }
}
